if (!customElements.get('product-tabs-block')) {
  customElements.define(
    'product-tabs-block',
    class ProductTabsBlock extends HTMLElement {
      connectedCallback() {
        if (this.dataset.tabsInitialized === 'true') return;
        this.dataset.tabsInitialized = 'true';

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
      }

      get tabs() {
        return Array.from(this.querySelectorAll('[data-product-tab]'));
      }

      get panels() {
        return Array.from(this.querySelectorAll('[data-product-tab-panel]'));
      }

      activateTab(tab) {
        const targetId = tab.getAttribute('aria-controls');

        this.tabs.forEach((item) => {
          const isActive = item === tab;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
          item.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.panels.forEach((panel) => {
          const isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      onClick(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.contains(tab)) return;
        this.activateTab(tab);
      }

      onKeydown(event) {
        const tab = event.target.closest('[data-product-tab]');
        if (!tab || !this.contains(tab)) return;

        const currentIndex = this.tabs.indexOf(tab);
        if (currentIndex === -1) return;

        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
          nextIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft') {
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        this.activateTab(this.tabs[nextIndex]);
        this.tabs[nextIndex].focus();
      }
    }
  );
}
